import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const NAMESPACES = [
  'common',
  'navigation',
  'auth',
  'onboarding',
  'forms',
  'validation',
  'profile',
  'dashboard',
  'pipeline',
  'documents',
  'tools',
  'chat',
  'dashboardAdmin',
];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    lng: 'en',
    ns: NAMESPACES,
    defaultNS: 'common',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'cookie'],
      caches: ['localStorage'],
    },
    react: {
      useSuspense: true,
    },
  })
  .then(() => {
    i18n.loadNamespaces(NAMESPACES);
  });

i18n.on('languageChanged', (lng) => {
  i18n.reloadResources(lng, NAMESPACES);
});

export default i18n;
